import { PermissionsApp } from "../services/auth/authorization/authorization-service-impl";

export const REVENUE_DASHBOARD_PATH = "/revenue-dashboard";
export const REVENUE_TOTAL_DEVENGADO_PATH = "/revenue-total-devengado";

export type AuthorizationLike = {
  hasPermission: (permission: PermissionsApp | string) => boolean;
};

/** Gestor Revenue (admin): transacciones + partners + activos revenue a nivel global. */
export function isGestorRevenueAdmin(autho: AuthorizationLike): boolean {
  return (
    autho.hasPermission(PermissionsApp.EditAllTransacciones) &&
    autho.hasPermission(PermissionsApp.EditAllPartners) &&
    autho.hasPermission(PermissionsApp.EditAllActivosRevenue)
  );
}
